import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';

const HeroSection = ({ scrollY }) => {
  const parallaxOffset = scrollY * 0.5;

  const scrollToTickets = () => {
    document.getElementById('tickets')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden" data-testid="hero-section">
      <div
        className="absolute inset-0 z-0"
        style={{
          transform: `translateY(${parallaxOffset}px)`,
          backgroundImage: 'url(https://static.prod-images.emergentagent.com/jobs/4336761a-9b88-46d2-9cc3-579e51e3676d/images/60dffc866e60b626b0f6b68cfe4f08d39a0e24abd794549a6e2502dce39e0556.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 z-10 hero-gradient" />
      
      <div className="relative z-20 text-center px-6 max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <p className="text-yellow-400 text-sm md:text-base uppercase tracking-widest mb-4 font-semibold" data-testid="hero-subtitle">
            An Immersive Cultural Experience
          </p>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight" data-testid="hero-title">
            Kerala Wedding Experience
          </h1>
          <p className="text-xl md:text-3xl text-stone-100 font-light mb-4 font-accent italic" data-testid="hero-tagline">
            All the vibe, none of the obligations.
          </p>
          <p className="text-base md:text-lg text-stone-200 mb-8" data-testid="hero-description">
            Sadya. Chenda. Kasavu. Photos. Just show up.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <Button 
              onClick={scrollToTickets}
              className="rounded-full bg-yellow-600 hover:bg-yellow-700 text-white px-10 py-6 text-lg font-semibold shadow-2xl hover:shadow-yellow-600/50 hover:-translate-y-1 transition-all duration-300"
              data-testid="book-tickets-btn"
            >
              Booking Will Be Open Soon
            </Button>
          </div>
          
          <div className="text-white text-sm md:text-base" data-testid="hero-event-info">
            <p className="font-semibold">Next Event: November 18 | Kerala</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
